import React from 'react';
import {Button, InfoMedia, SecSubTitle, SecTitle} from '../../components';

const AboutSevenTextImage = ()=> (
  <div className="background-image" style={{backgroundImage: 'url(images/bg/about-bg-5-1.jpg)'}}>
    <div className="container container-style1">
      <div className="row flex-row-reverse align-items-center gx-70">
        <div className="col-lg-6 col-xl">
          <img src="images/e-Invoice/e-invoice-1.jpeg" alt="aboutthumb"/>
        </div>
        <div className="col-lg-6 col-xl-auto">
          <div className="about-box2">
            <SecTitle className="text-capitalize h1">What is E-Invoicing?</SecTitle>
            <p >
              E-Invoicing (Electronic Invoicing) is the digital exchange of invoice documents between businesses and government authorities in a structured format. It replaces paper-based invoicing with a secure, automated, and tax-compliant process. Governments around the world are mandating E-Invoicing to improve transparency, reduce fraud, and increase tax collection efficiency.
              <br/>
              With regulations evolving quickly, it's crucial for businesses to adopt a compliant, future-proof solution.
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AboutSevenTextImage;